import { Table as AntdTable } from 'antd';
import { defaultProps, TableProps } from './Table.type';
import styles from "./Table.module.scss";
import cx from "classnames";

export const Table = (props: TableProps) => {
  const { className, ...attributes } = { ...defaultProps, ...props };

  return <AntdTable {...attributes} className={cx(styles.Table, className)} />;
};
